// Module
var code = "<div class=\"vertical-scroll-container\"> <div class=\"refer-choice\" layout=\"column\" layout-align=\"start center\"> <div class=\"loading\" ng-if=\"ctrl.isLoading\" layout layout-align=\"center center\"> <i class=\"ck ck-loading fa fa-spin fa-4x ck-green\"></i> </div> </div> </div> ";
// Exports
module.exports = code;